import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "statusDot"]
  static values = {
    heartbeatUrl: String,
    status: String
  }

  connect() {
    this.startHeartbeat()
  }

  disconnect() {
    this.stopHeartbeat()
  }

  startHeartbeat() {
    // Send heartbeat every 60 seconds
    this.heartbeatInterval = setInterval(() => {
      this.sendHeartbeat()
    }, 60_000)

    // Send initial heartbeat
    this.sendHeartbeat()
  }

  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
    }
  }

  async sendHeartbeat() {
    try {
      const response = await fetch(this.heartbeatUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        }
      })

      if (response.status === 410) {
        // Instance is gone - reload page to re-provision
        this.stopHeartbeat()
        window.location.reload()
      }
    } catch (error) {
      console.warn("Heartbeat failed:", error)
    }
  }
}
